export const CLIENT_ID = '2b467d30365e4954b54897641453a192'
export const SCOPES = 'streaming user-modify-playback-state user-read-email user-read-private'

// eslint-disable-next-line
export const REDIRECT_URI = process.env.VUE_APP_REDIRECT_URI
export const AUTHORIZATION_URL = 'https://accounts.spotify.com/authorize'
export const TOKEN_URL = 'https://accounts.spotify.com/api/token'

export const CODE_VERIFIER_KEY = 'countInCodeVerifier'
